function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 96h256v320H0zm0 0",
  fill: "#e9686a"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240 464H16L0 416h256zm0 0M256 96H0l16-64h224zm0 0",
  fill: "#dd3e46"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 0h224v32H16zm0 0",
  fill: "#cfdfe8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 296c89 7 178-13 256-56v32s-88 96-256 96zm0 0",
  fill: "#5a6470"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "M56 232H32c-4 0-8-4-8-8v-48c0-4 4-8 8-8h24v16H40v32h16zm0 0M112 232H80c-4 0-8-4-8-8v-48c0-4 4-8 8-8h32c4 0 8 4 8 8v48c0 4-4 8-8 8zm-24-16h16v-32H88zm0 0M168 232h-24c-4 0-8-4-8-8v-56h16v48h16zm0 0M224 168h-32c-4 0-8 4-8 8v56h16v-16h16v16h16v-56c0-4-4-8-8-8zm-24 32v-16h16v16zm0 0M128 120h16v16h-16zm0 0M232 152h-16v-16h-56v-16h64c4 0 8 4 8 8zm0 0"
}));

var SvgDrinksCan = function SvgDrinksCan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-104 0 464 464",
    width: "464pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDrinksCan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drinks-can.541c22ff.svg";
export { ForwardRef as ReactComponent };